import { useLocation } from 'react-router';
/**
 * Hook to determine if the user is currently in the /alpha app.
 *
 * @returns true if the current pathname starts with '/alpha', false otherwise
 */
export function useIsAlphaApp() {
    const { pathname } = useLocation();
    return pathname.startsWith('/alpha');
}
